import { HierarchyContextProps, IHierarchyActionSetHierarchyNameSaveBlocker } from "../interface";

/**
 * Sets or clears the hierarchy-name save blocker.
 *
 * @param state - The current hierarchy context state.
 * @param action - The set-hierarchy-name-save-blocker action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_setHierarchyNameSaveBlocker = (
  state: HierarchyContextProps,
  action: IHierarchyActionSetHierarchyNameSaveBlocker,
): HierarchyContextProps => ({
  ...state,
  saveBlockers: {
    ...state.saveBlockers,
    hierarchyName: action.warningText ?? undefined,
  },
});
